import './styles.scss'
import React from 'react'

const LikeButton = ({ actionSummaryList, onAddLike }) => {
  const likes = actionSummaryList.find((el) => el.type === 'THUMB') || { count: 0 }

  return (
    <div className='thumb-like-content d-flex align-items-center'>
      <img onClick={onAddLike} className='like-nixi' src='img/like_nixi1-02.png' alt='thumb-like-img' />

      <span className='thumb-count'>{likes.count}</span>
      <span className='thumb-like-text' onClick={onAddLike}>
        Like
      </span>
    </div>
  )
}

export default LikeButton
